import script from "./normalChangeOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./normalChangeOrder.vue?vue&type=script&setup=true&lang=js"

import "./normalChangeOrder.vue?vue&type=style&index=0&id=5f3c7ac1&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3c7ac1"]])

export default __exports__